export default __webpack_public_path__ + "static/media/miguel-lopes-37.68c4af9b.jpg";